const screens = {
  '2xs': '360px',
  xs: '480px',
  sm: '640px',
  md: '768px',
  '2md': '900px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px',
  '3xl': '1920px',
}

export default screens
